import type { ButtonHTMLAttributes } from "react";
import { Loader2, Save } from "lucide-react";
import { FLOW_ORANGE_ACTION_BUTTON_BASE } from "../../styles/twDesignPrimitives";

function cn(...parts: (string | undefined | false)[]) {
  return parts.filter(Boolean).join(" ");
}

interface SaveDraftButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  loadingLabel?: string;
}

function SaveDraftButton({
  isLoading = false,
  loadingLabel = "Salvando rascunho...",
  children = "Salvar como rascunho",
  className,
  disabled,
  type = "button",
  ...props
}: SaveDraftButtonProps) {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type={type}
      disabled={isDisabled}
      className={cn(
        FLOW_ORANGE_ACTION_BUTTON_BASE,
        "relative isolate min-h-[44px] w-auto min-w-[100px] shrink-0 gap-2 px-4 py-2.5 text-sm tracking-wide sm:px-5 sm:py-3",
        "shadow-sm shadow-[#DD6435]/25 hover:shadow-md hover:shadow-[#DD6435]/30",
        "ring-1 ring-inset ring-white/20",
        isDisabled && "opacity-70",
        className
      )}
      {...props}
    >
      {isLoading ? (
        <>
          <Loader2
            className="h-4 w-4 shrink-0 animate-spin"
            aria-hidden
          />
          <span className="truncate">{loadingLabel}</span>
        </>
      ) : (
        <>
          <Save className="h-4 w-4 shrink-0" aria-hidden />
          <span className="truncate">{children}</span>
        </>
      )}
    </button>
  );
}

export default SaveDraftButton;
